"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLine = exports.InputFieldWrapper = exports.DescriptionWrapper = exports.Title = exports.ButtonWrapper = exports.ControlsWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.ControlsWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(5, 0.5fr);
  grid-column-gap: 0.1%;
  grid-row-gap: 12%;
  align-items: center;
  width: fit-content;

  @media (max-width: 1199px) {
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 3%;
  }
`;
exports.ButtonWrapper = styled_components_1.default.div `
  margin-top: 35px;
  display: flex;
  grid-column-gap: 15px;
`;
exports.Title = styled_components_1.default.div `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 8px;
  color: ${colors_1.GREY4};

  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      label {
        font-size: 24px;
        line-height: 32px;
      }
    `}
`;
exports.DescriptionWrapper = styled_components_1.default.div `
  margin-bottom: 23px;
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: ${colors_1.GREY3};
`;
exports.InputFieldWrapper = styled_components_1.default.div `
  width: 300px;
  margin-right: 26px;
`;
exports.HorizontalLine = styled_components_1.default.hr `
  background: ${colors_1.GREY1};
  margin: 56px 0px 48px 0px;
  border: 1px solid ${colors_1.GREY1};
`;
//# sourceMappingURL=SettingsBox.styles.js.map